import { useState, useCallback, useEffect } from 'react';
import { MAX_ATTEMPTS, STORAGE_KEY } from '@/components/verification/VerificationButton/constants';

interface UseVerificationAttemptsReturn {
  attempts: number;
  hasReachedLimit: boolean;
  incrementAttempts: () => void;
  decrementAttempts: () => void;
  resetAttempts: () => void;
}

export function useVerificationAttempts(): UseVerificationAttemptsReturn {
  const [attempts, setAttempts] = useState<number>(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? parseInt(stored, 10) : 0;
    } catch {
      return 0;
    }
  });

  const hasReachedLimit = attempts > MAX_ATTEMPTS;

  const incrementAttempts = useCallback(() => {
    setAttempts(prev => prev + 1);
  }, []);

  const decrementAttempts = useCallback(() => {
    setAttempts(prev => Math.max(0, prev - 1));
  }, []);

  const resetAttempts = useCallback(() => {
    setAttempts(0);
  }, []);

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, attempts.toString());
    } catch (error) {
      console.warn('Failed to persist attempts count:', error);
    }
  }, [attempts]);

  return {
    attempts,
    hasReachedLimit,
    incrementAttempts,
    decrementAttempts,
    resetAttempts
  };
}